let config = null;

if (process.env.VUE_APP_MODE === "production") {
  config = {
    url_api: "https://api.bukakasir.com/public/api/",
    base_url: window.location.origin + "/",
    images_url: "https://api.bukakasir.com/public/storage/images/",
    file_url: "https://api.bukakasir.com/public/storage/uploads/"
  };
} else if (process.env.VUE_APP_MODE === "demo") {
  config = {
    url_api: "https://apidemo.bukakasir.com/public/api/",
    base_url: "https://demo.bukakasir.com/",
    images_url: "https://apidemo.bukakasir.com/public/storage/images/",
    file_url: "https://apidemo.bukakasir.com/public/storage/uploads/"
  };
} else {
  config = {
    url_api: "http://localhost:8000/api/",
    base_url: window.location.origin + "/",
    images_url: "http://localhost:8000/storage/images/",
    file_url: "http://localhost:8000/storage/uploads/"
  };
}
export default config;
